<div class="view-wrapper table-view-wrapper" @viewLoader>
  <div class="view-content xl table-view">
    <div class="view-section">
      <div class="segments">
        <ct-lib-segmented-control
          [items]="segmentItems()"
          [selectedValue]="activeTab()"
          (valueChange)="setTab($event)"
        />
      </div>
      <div class="segment-content">
        @switch (activeTab()) {
          @case (PlatformJobsTab.RECOMMENDATIONS) {
            <app-platform-recommendations-list />
          }
          @case (PlatformJobsTab.SAVED) {
            <app-platform-jobs-saved />
          }
          @case (PlatformJobsTab.INVITATIONS) {
            <app-platform-jobs-invitations />
          }
        }
      </div>
    </div>
  </div>
</div>
